import { useState } from "react";
import { toast } from "@fox1ck-org/ui/toast";
import { useCreateUser } from "@/hooks/use-users";
import { Button, Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, Input } from "@fox1ck-org/ui";

interface Props {
  onClose: () => void;
}

export function CreateUserDialog({ onClose }: Props) {
  const [form, setForm] = useState({
    username: "",
    email: "",
    firstName: "",
    lastName: "",
    password: "",
    temporaryPassword: true,
    enabled: true,
  });

  const createUser = useCreateUser();

  const handleSubmit = () => {
    if (!form.username || !form.email) return;
    createUser.mutate(
      {
        username: form.username,
        email: form.email,
        firstName: form.firstName || undefined,
        lastName: form.lastName || undefined,
        password: form.password || undefined,
        temporaryPassword: form.temporaryPassword,
        enabled: form.enabled,
      },
      {
        onSuccess: () => { toast.success("Пользователь создан"); onClose(); },
        onError: (err) => toast.error(err.message),
      }
    );
  };

  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Новый пользователь</DialogTitle>
          <DialogDescription>Добавить пользователя на платформу.</DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-sm text-muted-foreground mb-1 block">Логин *</label>
              <Input value={form.username} onChange={(e) => setForm((f) => ({ ...f, username: e.target.value }))} placeholder="johndoe" />
            </div>
            <div>
              <label className="text-sm text-muted-foreground mb-1 block">Почта *</label>
              <Input type="email" value={form.email} onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))} placeholder="john@example.com" />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-sm text-muted-foreground mb-1 block">Имя</label>
              <Input value={form.firstName} onChange={(e) => setForm((f) => ({ ...f, firstName: e.target.value }))} />
            </div>
            <div>
              <label className="text-sm text-muted-foreground mb-1 block">Фамилия</label>
              <Input value={form.lastName} onChange={(e) => setForm((f) => ({ ...f, lastName: e.target.value }))} />
            </div>
          </div>

          <div>
            <label className="text-sm text-muted-foreground mb-1 block">Начальный пароль</label>
            <Input type="password" value={form.password} onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))} placeholder="Можно оставить пустым" />
          </div>

          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <input type="checkbox" id="temporary-pw" checked={form.temporaryPassword} onChange={(e) => setForm((f) => ({ ...f, temporaryPassword: e.target.checked }))} className="rounded" />
              <label htmlFor="temporary-pw" className="text-sm text-muted-foreground">Потребовать смену пароля</label>
            </div>
            <div className="flex items-center gap-2">
              <input type="checkbox" id="enabled" checked={form.enabled} onChange={(e) => setForm((f) => ({ ...f, enabled: e.target.checked }))} className="rounded" />
              <label htmlFor="enabled" className="text-sm text-muted-foreground">Включён</label>
            </div>
          </div>

          {createUser.error && <p className="text-sm text-destructive">{createUser.error.message}</p>}
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Отмена</Button>
          <Button onClick={handleSubmit} disabled={!form.username || !form.email || createUser.isPending}>
            {createUser.isPending ? "Создаём…" : "Новый пользователь"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
